<template>
  <div class="d-flex direction">
    <v-btn
      :title="$t('Sidebar.map')"
      :color="mapSwitchActive ? 'RMblack' : 'RMwhite'"
      class="pa-0"
      min-height="40"
      min-width="40"
      max-width="40"
      @click="mapSwitchActive = !mapSwitchActive"
    >
      <v-icon :color="mapSwitchActive ? 'grey' : 'black'">
        mdi-map-outline
      </v-icon>
    </v-btn>
    <div
      v-if="mapSwitchActive"
      class="d-flex direction pt-1"
    >
      <v-btn
        icon
        :title="$t('Sidebar.classic')"
        :min-height="btn"
        :min-width="btn"
        @click="setMapStyle('classic')"
      >
        <v-img
          :style="imgBorder('classic')"
          src="@/assets/map-classic.png"
          :width="btn"
        />
      </v-btn>
      <v-btn
        icon
        :title="$t('Sidebar.mountain')"
        :min-height="btn"
        :min-width="btn"
        @click="setMapStyle('mountain')"
      >
        <v-img
          :style="imgBorder('mountain')"
          src="@/assets/map-mountain.png"
          :width="btn"
        />
      </v-btn>
      <v-btn
        icon
        :title="$t('Sidebar.satellite')"
        :min-height="btn"
        :min-width="btn"
        @click="setMapStyle('satellite')"
      >
        <v-img
          :style="imgBorder('satellite')"
          src="@/assets/map-satellite.png"
          :width="btn"
        />
      </v-btn>
      <v-btn
        icon
        :title="$t('Sidebar.light')"
        :min-height="btn"
        :min-width="btn"
        @click="setMapStyle('light')"
      >
        <v-img
          :style="imgBorder('light')"
          src="@/assets/map-light.png"
          :width="btn"
        />
      </v-btn>
      <v-btn
        icon
        :title="$t('Sidebar.grey')"
        :min-height="btn"
        :min-width="btn"
        @click="setMapStyle('grey')"
      >
        <v-img
          :style="imgBorder('grey')"
          src="@/assets/map-grey.png"
          :width="btn"
        />
      </v-btn>
      <v-btn
        icon
        :title="$t('Sidebar.dark')"
        :min-height="btn"
        :min-width="btn"
        @click="setMapStyle('dark')"
      >
        <v-img
          :style="imgBorder('dark')"
          src="@/assets/map-dark.png"
          :width="btn"
        />
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data: () => ({
    mapSwitchActive: false,
    classicSelected: true,
    mountainSelected: false,
    satelliteSelected: false,
    lightSelected: false,
    greySelected: false,
    darkSelected: false,
    btn: 40
  }),
  computed: {
    ...mapState(['map'])
  },
  methods: {
    ...mapActions(['setMapStyle']),
    imgBorder(style) {
      const selected = style === this.map.mapStyle;

      return `border: 2px solid ${selected ? '#0ca344' : '#000'}; border-radius: 5px;`;
    }
  }
};
</script>

<style scoped>
  .direction > .direction > .v-btn {
    margin-bottom: 4px;
  }
  .direction {
    flex-direction: column;
  }

  @media (max-device-width: 599px){
    .direction {
      flex-direction: column-reverse!important;
    }
  }

  @media (max-device-width: 599px) and (orientation: landscape){
    .direction {
      flex-direction: row!important;
      flex-wrap: nowrap!important;
    }
    .direction > .direction > .v-btn {
      margin-bottom: 0px!important;
      margin-left: 4px;
    }
  }
</style>
